import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { CommonTypesDatalistsPage } from 'src/app/model/page/group/api-docs/common-types-datalists-page';
import { CommonTypesDataListsDetailsXMLSection } from 'src/app/model/section/common-types-datalists-details-xml-section';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-common-types-datalists-page',
  templateUrl: './common-types-datalists-page.component.html',
  styleUrls: ['./common-types-datalists-page.component.scss']
})
export class CommonTypesDatalistsPageComponent implements OnInit {
  @Input() pageTitle = '';

  commonTypesDatalistsPage: CommonTypesDatalistsPage = {} as CommonTypesDatalistsPage;
  commonTypesDataListsDetailsXMLSectionMap = new Map();
  isNoteSectionExist: boolean = false;
  isindexXMLSamplesSectionExist: boolean = false;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInitWithPageTitle(pageTitle: string) {
    // console.log('>>>> >>>> CommonTypesDatalistsPageComponent invoked ngOnInitWithPageTitle');
    this.pageTitle = pageTitle;
    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'common-types-data-lists') {
        this.commonTypesDatalistsPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': this.pageTitle, include: 2 };
    this.commonTypesDataListsDetailsXMLSectionMap = new Map();
    this.commonTypesDatalistsPage.pageContentTitle = '';
    this.commonTypesDatalistsPage.schemaDataModelAccordians = [];
    this.commonTypesDatalistsPage.commonTypesDataListsDetailsXMLSections = [];
    this.commonTypesDatalistsPage.noteSections = [];
    this.contentfulService.getPageContentResponse(query).then((commonTypesDatalistsPageEntries) => {
      this.mapBanners(commonTypesDatalistsPageEntries.includes.Entry, query);
      this.sharedDataService.addSharedData(this.commonTypesDatalistsPage.banner);
      this.mapSections(commonTypesDatalistsPageEntries.includes.Entry);
      this.mapSubSectionToSection();
      this.mapPageInfo(commonTypesDatalistsPageEntries.items);

      this.commonTypesDatalistsPage.commonTypesDataListsDetailsXMLSections.forEach((parentSection) => {
        parentSection.subSections!.sort((a, b) => a.order - b.order);
      });

      // console.log('parent sections with sub sections : ', this.commonTypesDatalistsPage.commonTypesDataListsDetailsXMLSections);
    });
  }

  private mapBanners(commonTypesDatalistsPageEntries: Entry<any>[], query: any) {
    if (commonTypesDatalistsPageEntries) {
      commonTypesDatalistsPageEntries
        .filter((entry) => ModelValidator.isBanner(entry))
        .forEach((entry) => {
          this.mapEntryToBanner(entry, query);
        });
    }
  }

  private mapEntryToBanner(entry: Entry<any>, query: any) {

    
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    let imageDetails: any = entry.fields['image'];

    this.commonTypesDatalistsPage.banner = {
      title: pageTitle,
      subTitle: entry.fields['subTitle']as string,
      image: imageDetails.fields.file.url as string,
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.commonTypesDatalistsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.commonTypesDatalistsPage.banner.url = entry.fields?.url;
      this.commonTypesDatalistsPage.banner.editorEmail = editorDetails?.pop();
      this.commonTypesDatalistsPage.banner.editorShortName = editorDetails?.pop();
      this.commonTypesDatalistsPage.banner.editorFullName = editorDetails?.pop();
      this.commonTypesDatalistsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
  private mapSections(commonTypesDatalistsPageEntries: Entry<any>[]) {
    commonTypesDatalistsPageEntries
      .filter((entry) => ModelValidator.isSection(entry) || ModelValidator.isTableSection(entry) || ModelValidator.isNote(entry))
      .forEach((entry) => {
        if (entry.fields['xml'] === undefined && ModelValidator.isSection(entry) && entry.fields['group'] === 'accordion') {
          this.mapNonXMLSectionToEntries(entry);
        } else if (ModelValidator.isNote(entry) && entry.fields['group'] === 'note-outside-details-xml-section') {
          this.mapNoteSectionOutsideDetailsXMLSection(entry);
        } else {
          let commonTypesDataListsDetailsXMLSection: CommonTypesDataListsDetailsXMLSection = {
            order: entry.fields['order']  as number,
            title: '',
            fullTitle: entry.fields['title'] as string,
            group: entry.fields['group'] as string,
            category: entry.fields['category'] as string,
            body: entry.fields['body'] as string,
            subBody: entry.fields['subBody'] as string,
            tableSections: [],
            noteSections: [],
            heading: entry.fields['heading'] as string
          };
          if (ModelValidator.isSection(entry)) {

            let pageTitle:any=entry.fields['title'] as string;
            commonTypesDataListsDetailsXMLSection = {
              order: entry.fields['order'] as number,
              title: pageTitle.split('#').pop(),
              heading: entry.fields['heading']  as string,
              fullTitle: entry.fields['title']  as string,
              group: entry.fields['group']  as string,
              category: entry.fields['category']  as string,
              body: entry.fields['body'] as string,
              subBody: entry.fields['subBody'] as string,
              subSections: [],
              tableSections: [],
              xmlDataArray: [],
              noteSections: []
            };
          }

          if (commonTypesDataListsDetailsXMLSection.category !== 'sub-section') {
            this.mapTableSection(commonTypesDataListsDetailsXMLSection, commonTypesDatalistsPageEntries);
          }

          this.mapNoteSectionToDetailsXMLSection(commonTypesDataListsDetailsXMLSection, commonTypesDatalistsPageEntries);

          if (ModelValidator.isSection(entry)) {
            if (!this.commonTypesDatalistsPage.pageContentTitle) {
              this.commonTypesDatalistsPage.pageContentTitle = entry.fields['heading'] as string;
            }

            this.mapXMLSectionToEntries(commonTypesDataListsDetailsXMLSection, entry.fields['xml']);
          }
        }
      });
  }

  private mapNonXMLSectionToEntries(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;

    this.commonTypesDatalistsPage.schemaDataModelAccordians.push({
      title: givenTitle.split('#').pop(),
      body: entry.fields['body'] as string,
      subBody: entry.fields['subBody'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      heading: entry.fields['heading'] as string
    });
    this.commonTypesDatalistsPage.pageContentTitle = entry.fields['heading'] as string;
  }

  private mapNoteSectionToDetailsXMLSection(commonTypesDataListsDetailsXMLSection: CommonTypesDataListsDetailsXMLSection, commonTypesDatalistsPageEntries: Entry<any>[]) {
    commonTypesDatalistsPageEntries
      .filter((entry) => ModelValidator.isNote(entry) && commonTypesDataListsDetailsXMLSection.fullTitle === entry.fields['group'])
      .forEach((entry) => {

        let pageTitle:any=entry.fields['title'] as string;
        commonTypesDataListsDetailsXMLSection.noteSections?.push({
          title: pageTitle.split('#').pop(),
          body: entry.fields['body'] as string,
          group: entry.fields['group'] as string,
          category: entry.fields['category'] as string,
          order: entry.fields['order'] as number,
          fullTitle: entry.fields['title'] as string,
          iconClass: entry.fields['iconClass'] as string
        });
      });
  }

  private mapNoteSectionOutsideDetailsXMLSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.commonTypesDatalistsPage.noteSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      category: entry.fields['category'] as string,
      order: entry.fields['order'] as number,
      fullTitle: entry.fields['title'] as string,
      iconClass: entry.fields['iconClass'] as string,
      noteClass: entry.fields['noteClass'] as string
    });
    this.commonTypesDatalistsPage.noteSections.sort((a, b) => a.order - b.order);
  }

  private mapTableSection(commonTypesDataListsDetailsXMLSection: CommonTypesDataListsDetailsXMLSection, commonTypesDatalistsPageEntries: Entry<any>[]) {
    commonTypesDatalistsPageEntries
      .filter((entry) => ModelValidator.isTableSection(entry) && commonTypesDataListsDetailsXMLSection.fullTitle === entry.fields['group'])
      .forEach((entry) => {
        this.mapTableSectionToDetailsXMLSections(commonTypesDataListsDetailsXMLSection, entry);
      });
  }

  private mapTableSectionToDetailsXMLSections(commonTypesDataListsDetailsXMLSection: CommonTypesDataListsDetailsXMLSection, entry: Entry<any>) {
    commonTypesDataListsDetailsXMLSection.tableSections?.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string
    });
  }

  private mapXMLSectionToEntries(commonTypesDataListsDetailsXMLSection: CommonTypesDataListsDetailsXMLSection, xmlFiles: any) {
    // console.log('>>>> xml files : ', xmlFiles);

    let xmlDataArray: any[] = [];
    xmlFiles?.content
      .filter((xmlFileContent: { nodeType: string }) => xmlFileContent.nodeType === 'embedded-asset-block')
      .forEach((element: any) => {
        let xmlTitle = element?.data?.target?.fields?.title?.split('#').pop();
        this.httpClient.get(element?.data?.target?.fields?.file.url, { responseType: 'text' }).subscribe({
          next: (data) => xmlDataArray.push({ data: data, title: xmlTitle }),
          error: (cause) => xmlDataArray.push({ data: cause.message, title: xmlTitle })
        });
      });

    this.mapXMLSectionToEntriesWithXMLData(commonTypesDataListsDetailsXMLSection, xmlDataArray);
  }

  private mapXMLSectionToEntriesWithXMLData(commonTypesDataListsDetailsXMLSection: CommonTypesDataListsDetailsXMLSection, xmlDataArray: any[]) {
    commonTypesDataListsDetailsXMLSection.xmlDataArray = xmlDataArray;
    this.commonTypesDataListsDetailsXMLSectionMap.set(commonTypesDataListsDetailsXMLSection.heading + '##' + commonTypesDataListsDetailsXMLSection.fullTitle, commonTypesDataListsDetailsXMLSection);
    this.commonTypesDatalistsPage.commonTypesDataListsDetailsXMLSections = [...this.commonTypesDataListsDetailsXMLSectionMap.values()]
      .filter((section) => section.category !== 'sub-section')
      .sort((a, b) => a.order - b.order);
  }

  private mapSubSectionToSection() {
    [...this.commonTypesDataListsDetailsXMLSectionMap.values()]
      .filter((section) => section.category === 'sub-section')
      .forEach((subSection) => {
        this.commonTypesDatalistsPage.commonTypesDataListsDetailsXMLSections.forEach((parentSection) => {
          if (parentSection.fullTitle === subSection.group) {
            parentSection.subSections?.push(subSection);
          }
        });
      });
  }
}
